import React, {useEffect, useRef, useState} from "react";
import {useInView} from "react-intersection-observer";

interface HideableComponentProps {
    children: React.ReactNode;
    isVisibleCallback: (v: boolean) => void
}

export const HideableComponent: React.FC<HideableComponentProps> = ({children, isVisibleCallback}) => {
    const {ref, inView, entry} = useInView({delay: 2});

    const [isVisible, setIsVisible] = React.useState(false);
    const [maxHeight, setmaxHeight] = useState(0);

    const prevInView = useRef(inView);
    const prevEntry = useRef(entry);


    useEffect(() => {
        if (prevInView.current !== inView) {
            setIsVisible(inView);
            prevInView.current = inView;
        }
    }, [inView]);

    useEffect(() => {
        if (prevEntry.current !== entry) {
            prevEntry.current = entry;
        }
        if (entry && entry.boundingClientRect) {
            if (entry.boundingClientRect.height > 0 && entry.boundingClientRect.height < maxHeight) {
                setmaxHeight(entry.boundingClientRect.height);
            }
        }
    }, [entry]);


    if (isVisible) {
        isVisibleCallback(true);
        return <div style={{maxWidth: '100%', width: '100%'}} ref={ref}>{children}</div>;
    }

    isVisibleCallback(false);
    return <div ref={ref} style={{height: maxHeight > 100 ? maxHeight + 'px' : '100px', width: '100%'}}></div>;

};